import { ComputedRef } from 'vue'

import { createNullableProvideInject } from '@collector/shared-ui'

import { GetEventClockTime, IsValidEventClockTime } from '../../configuration'

type EventClockHelpers = {
  currentPeriodLengthMinutes: ComputedRef<number | null>
  currentPeriodStartOffsetMinutes: ComputedRef<number | null>
  isTimerDirectionDown: ComputedRef<boolean>
  isValidEventClockTime: IsValidEventClockTime
  getEventClockTime: GetEventClockTime
  minutesMaxDigits: number
}

export const [provideEventClockHelpers, injectEventClockHelpers] =
  createNullableProvideInject<EventClockHelpers>('eventClockHelpers')
